const getHeadline = (suburbname, hl) => {

  if (suburbname == undefined) {
    return 'Find the top real estate agents in your area';
  }

  let headline = `Compare the top real estates in ${suburbname}`;
  const lastChar = suburbname.substr(suburbname.length - 1);
  let suburbplural = null;
  const headlineSuburbParam = `in ${suburbname}`;

  if (lastChar == 's') {
    suburbplural = suburbname;
  } else {
    suburbplural = `${suburbname}'s`;
  }

  switch (hl) {
    case '0':
      headline = 'Find the top real estate agents in your area';
      break;

    case '1':
      headline = 'Compare local agent commission and fees';
      break;

    case '2':
      headline = 'Sell your house faster and for more';
      break;

    case '3':
      headline = 'Compare local agent reviews and sales';
      break;

    case '4':
      headline = 'Compare the top real estate agents in your area';
      break;

    case '5':
      headline = 'Compare the top selling agents in your area';
      break;

    case '6':
      headline = `Compare ${suburbplural} top real estate agents`;
      break;

    case '7':
      headline = `Find ${suburbplural} top real estate agents`;
      break;

    case '8':
      headline = `Find the top real estate agents ${headlineSuburbParam}`;
      break;

    case '9':
      headline = `Find top selling agents ${headlineSuburbParam}`;
      break;

    case '10':
      headline = `Compare real estate agents ${headlineSuburbParam}`;
      break;

    case '11':
      headline = `Compare the top agents ${headlineSuburbParam}`;
      break;

    case '12':
      headline = `Compare ${suburbplural} top selling agents`;
      break;

    case '13':
      headline = `Find top 10 agents ${headlineSuburbParam}`;
      break;

    case '14':
      headline = 'Find the top 10 real estate agents in your area';
      break;

    case '15':
      headline = `Compare commissions & sales from the top 10 agents ${headlineSuburbParam}`;
      break;

    case '16':
      headline = 'Find top property managers in your area';
      break;

    case '17':
      headline = 'Find the #1 selling real estate agent in your area';
      break;

    case '18':
      headline = 'Find the top real estate agents in 2018';
      break;

    case '19':
      headline = 'How much should you be paying for agent commission?';
      break;

    case '20':
      headline = 'Find the top 3 agents in your area';
      break;

    case '21':
      headline = 'Find the highest selling agents in your area';
      break;

    case '22':
      headline = `Access our 5-Star property manager for ${suburbname}`;
      break;

    case '23':
      headline = `Access the top property manager in ${suburbname}`;
      break;

    case '24':
      headline = 'Compare Property Management Offers';
      break;

    case '25':
      headline = `Compare property management offers in ${suburbname}`;
      break;

    default:
      headline = `Compare the top real estates in ${suburbname}`;
  }
  return headline;
};

export default {
  getHeadline,
};
